<template>
	<div id="app">
		<Head v-show="this.$store.state.name"></Head>
		<router-view v-show="this.$store.state.name"></router-view>
		<Footer ref="footer" v-show="this.$store.state.name"></Footer>
		<scrollTop />
	</div>
</template>

<script>
	import Head from "@/components/Head/head.vue";
	import Footer from "@/components/Footer/footer.vue";

	export default {
		name: "App",

		components: {
			Head,
			Footer,
		},
		data() {
			return {};
		},
		watch: {},
		created() {},
		methods: {},
	};
</script>

<style lang="less" scoped></style>
